// auth-form.jsx
import React, {useState} from 'react';
import Input from "./Input";
import Button from "../Button";

function getServerAddress() {
    return process.env.REACT_APP_API_ENDPOINT;
}

const AuthForm = () => {
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isCompletedWithSuccess, setIsCompletedWithSuccess] = useState(false);

    const handleSocialLogin = async (provider) => {
        // Rediriger vers le fournisseur d'identité
        try {
            const apiEndpoint = getServerAddress() + `api/auth/login/${provider}`;
            console.log(apiEndpoint)
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    redirectUrl: getServerAddress() + `api/auth/callback`
                })
            });

            console.log(response)
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                window.location.href =data.redirectUrl;
                setIsCompletedWithSuccess(true);
            }else{
                setIsError(true) ;
                setErrorMessage("Problème lors de l'enregistrement en base" );
            }
        } catch (error) {
            console.error('Erreur de connexion sociale:', error);
            setIsError(true) ;
            setErrorMessage("Problème avec le fournisseur d'identité " + error);
        }
    };

    return (
        <div>


            <button className="primary-button"
                onClick={() => handleSocialLogin('microsoft')}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M0 0h12v12H0V0zm13 0h12v12H13V0zm0 13h12v12H13v-12zm13 0h12v12h-12v-12z"/>
                </svg>
                <span style={{marginLeft:'6px'}}>Microsoft</span>
            </button>

            <button className="primary-button"
                    onClick={() => handleSocialLogin('google')}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                <span style={{marginLeft:'6px'}}>Google</span>
            </button>

            <button className="primary-button"
                    onClick={() => handleSocialLogin('linkedin')}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.609c1.358-2.518 7-2.779 7 2.476v6.759z"/>
                </svg>
                <span style={{marginLeft:'6px'}}>LinkedIn</span>
            </button>

            {/*<button className="primary-button"*/}
            {/*        onClick={() => handleSocialLogin('okta')}*/}
            {/*>*/}
            {/*    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">*/}
            {/*        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>*/}
            {/*    </svg>*/}
            {/*    <span style={{marginLeft:'6px'}}>Okta</span>*/}
            {/*</button>*/}

            {isError && <div className="error-message">{errorMessage}</div>}
            {isCompletedWithSuccess && <div className="p-badge-success">Transmis avec succès</div>}

        </div>
    );
};

export default AuthForm;

